/*
 * @Date: 2020-08-11 19:24:21
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-23 22:19:16
 * @FilePath: \pc-mall\src\common\js\common.js
 */
/** ************************************时间格式化处理************************************/
export function dateFtt(fmt, date) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

// 获取最近几天
export function getNearMonth(day) {
  var today = new Date()
  today.setMonth(today.getMonth() - day);
  let month = today.getTime() + 1000 * 60 * 60 * 24
  today.setTime(month)
  return today
}